import {
    axisTextDim1,
    colonAnnotation, fw_progressive_1way,
    inrFormatter,
    make_x_gridlines,
    numberFormat,
    responsivefy,
    XaxisAttribute
} from "../functions";
import * as d3 from "d3";

export default function (chart, divId, vizName, resData, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId).append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + 2 * chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    var x1Scale = d3.scaleLinear().range([0, chart.width])
    var y1Scale = d3.scaleBand().range([chart.height, 0]).paddingInner(.3)
    var x1AxisLabel = d3.axisBottom(x1Scale).ticks(8).tickFormat(numberFormat)
    var y1AxisLabel = d3.axisLeft(y1Scale)
    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

    // axios.post(url, filterParam).then(res => {
        let data = resData

        data.sort((a, b) => {
            return a.metric1 - b.metric1
        })

        x1Scale.domain([0, d3.max(data, (d) => {
            return d.metric1
        })])
        y1Scale.domain(data.map((d) => {
            return d.dim1_name
        })).paddingInner(0.3)

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('g')
            .attr('class', 'y axis')
            .call(y1AxisLabel)
            .attr('transform', 'translate(' + x1Scale(0) + ',0)')
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .attr('dy', '-0.55em')
            .text(axisTextDim1)

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize - 6)

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', 0 - (chart.margin.top / 2))
            .attr('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.x2AxisDisplayName)
            .style('font-size', fontSize - 6)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 3))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
             var y1tip = tooltip_class()

             y1tip.attr('class', 'd3-tip'+divId.id).html((d) =>{
                    return d.dim1_name+ colonAnnotation+ numberFormat(d.metric1)
            })

            svg.call(y1tip);*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            /*svg.append("g")
                  .attr("class", "grid")
                  .call(make_y_gridlines(y1Scale)
                      .tickSize(-chart.width)
                      .tickFormat(""))*/
        }

        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('height', y1Scale.bandwidth())
            .attr('y', d => {
                return y1Scale(d.dim1_name)
            })
            .attr('width', d => {
                return x1Scale(d.metric1)
            })
            .style('fill', (d) => {
                return metric1ColorScale(d.dim1_name)
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(
                    d.dim1_name + colonAnnotation + inrFormatter(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
    // })
}